import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useTemporaryResevation = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const addTemporaryReservation = async ({
    productId,
    entertainmentId,
    resourceId,
    dateOfEvent,
    categories,
    duration,
    pricingId,
    startTime,
    packageSelected = null,
    overbooking = false,
  }) => {
    try {
      const response = await sendRequest({
        url: `/api/v1/temporaryReservation/add`,
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        params: { overbooking },
        body: {
          productId,
          entertainmentId,
          resourceId,
          dateOfEvent,
          categories,
          duration,
          pricingId,
          startTime,
          packageSelected,
        },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const updatePackageOfTemporaryReservation = async (temporaryReservationId, packageId) => {
    try {
      const response = await sendRequest({
        url: `/api/v1/temporaryReservation/${temporaryReservationId}/package`,
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        body: { packageId },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const updateUpsellsOfTemporaryReservation = async (temporaryReservationId, upsells) => {
    try {
      const response = await sendRequest({
        url: `/api/v1/temporaryReservation/${temporaryReservationId}/upsells`,
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        body: { upsells },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const invalidateTemporaryReservation = async temporaryReservationId => {
    try {
      const response = await sendRequest({
        url: `/api/v1/temporaryReservation/${temporaryReservationId}/invalidate`,
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const getTemporaryReservationsByEntertainmentAndDate = async (entertainmentId, date) => {
    try {
      const response = await sendRequest({
        url: `/api/v1/temporaryReservation/special/by-date`,
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        params: {
          entertainmentId,
          date,
        },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const applyDiscountToReservation = async (temporaryReservationId, code) => {
    try {
      const response = await sendRequest({
        url: `/api/v1/temporaryReservation/${temporaryReservationId}/applyDiscount`,
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
        body: { code },
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  const removeDiscountFromReservation = async temporaryReservationId => {
    try {
      const response = await sendRequest({
        url: `/api/v1/temporaryReservation/${temporaryReservationId}/discount`,
        method: 'DELETE',
        headers: authCtx.getAuthHeaders(),
      });
      return response;
    } catch (err) {
      throw err;
    }
  };

  return {
    isLoading,
    error,
    addTemporaryReservation,
    updatePackageOfTemporaryReservation,
    updateUpsellsOfTemporaryReservation,
    invalidateTemporaryReservation,
    getTemporaryReservationsByEntertainmentAndDate,
    applyDiscountToReservation,
    removeDiscountFromReservation,
  };
};

export default useTemporaryResevation;
